// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@sc/Overrides/Widgets/Brand/BrandGallery";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

listStyles.container = {
    css: css`
        && {
            .swiper-slide {
                justify-content: flex-start;
            }
        }
    `,
};

listStyles.image = {
    width: "149px",
    height: "149px",
    css: css`
        width: 149px;
        height: 149px;
        ${xScreen("lte", "md")} {
            width: 169px;
            height: 169px;
        }
        &&&& img {
            height: 100%;
            width: 100%;
            max-width: 100%;
            max-height: 100%;
            border-radius: 4px;
        }
    `,
};
listStyles.brandName = {
    color: "text",
    typographyProps: {
        size: 16,
        lineHeight: "22px",
        css: css`
            text-align: center;
        `,
    },
};
listStyles.contentWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
    `,
};
